/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import { hover } from '../../utils/cssUtils';

type Props = {
  className?: string,
  disabled?: boolean,
  onClick: () => void,
};

const defaultProps = {
  className: undefined,
  disabled: false,
};

const ClearIcon = glamorous.button(
  {
    outline: 'none',
    padding: 0,
    ...hover({
      opacity: 0.7,
    }),
  },
  'ion-close-round',
);

function ClearButton({ className, disabled, onClick }: Props) {
  return (
    <ClearIcon
      type="button"
      className={className}
      disabled={disabled}
      onClick={onClick}
    />
  );
}

ClearButton.defaultProps = defaultProps;

export default ClearButton;
